/** Pick a WebLLM model from device memory. No network. */

export const EDGE_MODELS = {
  '8b': 'Llama-3.1-8B-Instruct-q4f16_1-MLC',
  '3b': 'Llama-3.2-3B-Instruct-q4f16_1-MLC',
  '1b': 'Llama-3.2-1B-Instruct-q4f16_1-MLC',
  '0.5b': 'Qwen2.5-0.5B-Instruct-q4f16_1-MLC',
};

export function pickEdgeModel({
  hasWebGpu = false,
  maxBufferSize = 0,
  deviceMemoryGb = 0,
} = {}) {
  if (!hasWebGpu) {
    return { model: null, tier: 'none', fallback: 'master', reason: 'webgpu_unavailable' };
  }
  const bufGb = Number(maxBufferSize || 0) / 1024 ** 3;
  if (bufGb >= 4 || deviceMemoryGb >= 16) {
    return { model: EDGE_MODELS['8b'], tier: '8b', fallback: '3b', reason: 'flagship-8b' };
  }
  if (bufGb >= 2 || deviceMemoryGb >= 8) {
    return { model: EDGE_MODELS['3b'], tier: '3b', fallback: '1b', reason: 'flagship' };
  }
  if (bufGb >= 0.5 || deviceMemoryGb >= 6) {
    return { model: EDGE_MODELS['1b'], tier: '1b', fallback: '0.5b', reason: 'standard' };
  }
  return { model: EDGE_MODELS['0.5b'], tier: '0.5b', fallback: 'master', reason: 'constrained' };
}

export function smallerTier(tier) {
  if (tier === '8b') return '3b';
  if (tier === '3b') return '1b';
  if (tier === '1b') return '0.5b';
  return 'none';
}

/** Path A boots 1B so the PC answers before the 3B/8B weights finish. */
export const JOB_BOOT_MODEL = EDGE_MODELS['1b'];

export function tierFromModel(model) {
  const m = String(model || '');
  if (/8B/i.test(m)) return '8b';
  if (/3B/i.test(m)) return '3b';
  if (/1B/i.test(m)) return '1b';
  if (/0\.5B/i.test(m)) return '0.5b';
  return null;
}

export function bootModelForJobs(route = {}) {
  if (!route || route.path === 'C' || route.acceptJobs === false) return null;
  if (route.tier === '8b' || route.tier === '3b') return JOB_BOOT_MODEL;
  return route.model || JOB_BOOT_MODEL;
}

/**
 * Guest-PC WebLLM budget. Keep the KV window on THEIR GPU.
 * 3B / 16GB-class → 4096. 1B laptop → 2048. Phone 0.5B → 1024.
 */
export function guestInferTune(tier = '1b') {
  const t = String(tier || '1b');
  if (t === '8b') {
    return { context_window_size: 4096, max_tokens: 1024, query_chars: 6000, history_chars: 1500 };
  }
  if (t === '3b') {
    return { context_window_size: 4096, max_tokens: 768, query_chars: 5000, history_chars: 1200 };
  }
  if (t === '1b') {
    return { context_window_size: 2048, max_tokens: 512, query_chars: 3500, history_chars: 800 };
  }
  return { context_window_size: 1024, max_tokens: 256, query_chars: 1800, history_chars: 500 };
}
